import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var caution_filled_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12.75 8V13H11.25V8H12.75ZM12.75 14.5V16H11.25V14.5H12.75Z" }) });
export {
  caution_filled_default as default
};
//# sourceMappingURL=caution-filled.js.map
